import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/company_page/pages/settings/RootPage'))

const CompanyPageSettings = React.lazy(
  () => import('modules/company_page/pages/CompanyPageSettings/index')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.company_page.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'company-page'),
      },
      children: [
        {
          index: true,
          element: <CompanyPageSettings />,
        },
      ],
    },
  ]
}

export default settingsRoutes
